export function getScrollProps(props) {
    var propsToUse = {
        onScroll: props.onScroll,
        onScrollCapture: props.onScrollCapture,
        onWheel: props.onWheel,
        onWheelCapture: props.onWheelCapture,
    };
    var variables = {};
    if (props.scrollSimple === true || props.scrollVariant === 'simple') {
        variables.scrollSimple = true;
        props.noScroll = true;
    }
    var classes = {
        '__content-scroll': !props.noScroll && props.scroll && !props.scrollOnlyVertical && !props.scrollOnlyHorizontal,
        '__content-no-scroll': props.noScroll === true,
        '__content-scroll-vertical': !props.noScroll && props.scrollOnlyVertical,
        '__content-scroll-horizontal': !props.noScroll && props.scrollOnlyHorizontal,
    };
    return {
        classes: classes,
        props: propsToUse,
        styles: {},
        variables: variables
    };
}
